import { useFormContext, useWatch } from "react-hook-form";

import { useRateContext } from "../../../../Context/RateContext";
import { useRateFieldName } from "../../../../hooks/useRateFieldName";

import { useSalesTaxAvailability } from "@/common/hooks/useSalesTaxAvailability";
import { isRateTaxable } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/helpers/rateTaxes";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const useShowTaxRow = (): boolean => {
  const { isSalesTaxManagementAvailable } = useSalesTaxAvailability();
  const { formCategory } = useRateContext();
  const { control } = useFormContext<StepTicketsFormData>();

  const amount = useWatch({ control, name: useRateFieldName("amount") });
  const isPayWhatYouCan = useWatch({ control, name: useRateFieldName("isPayWhatYouCan") });

  if (!isSalesTaxManagementAvailable) {
    return false;
  }
  return isRateTaxable({ amount, isPayWhatYouCan }, formCategory);
};
